/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandableItemMenu } from "./d-theme-white-menu-item-expandable-item-menu";

export class DThemeWhiteMenuSidedItemExpandableItemMenu extends DThemeWhiteMenuItemExpandableItemMenu {}
